import {useLazyQuery, gql} from '@apollo/client'

const LONGITUDINAL_COUNTY_LIST_QUERY = gql`
  query longitudinalCountyList($state: AlphabetOnly!) {
    longitudinalCountyList(STATE_ABBREVIATION: $state) {
      COUNTY_NAME
      STATE_COUNTY_FIPS_CODE
      STATE_ABBREVIATION
    }
  }
`

const QUERY_ALL_COUNTY_LIST = gql`
  query longitudinalCountyList {
    longitudinalCountyList {
      COUNTY_NAME
      STATE_COUNTY_FIPS_CODE
      STATE_ABBREVIATION
    }
  }
`

export function useQueryCountyState() {
  const [queryCounty, {data: county, loading: loadingCounty, refetch: refetchCounty, error: errorLoadingCounty}] =
    useLazyQuery(LONGITUDINAL_COUNTY_LIST_QUERY, {
      context: {clientName: 'longitudinal'}
    })

  return [
    queryCounty,
    {
      county,
      loadingCounty,
      refetchCounty,
      errorLoadingCounty
    }
  ]
}

/**
 * Query hook for fetching all counties (no state filter)
 * Used by time series components
 */
export function useQueryAllCounties() {
  const [
    queryAllCounty,
    {data: allCounty, loading: loadingAllCounty, refetch: refetchAllCounty, error: errorLoadingAllCounty}
  ] = useLazyQuery(QUERY_ALL_COUNTY_LIST, {
    context: {clientName: 'longitudinal'}
  })

  return [
    queryAllCounty,
    {
      allCounty,
      loadingAllCounty,
      refetchAllCounty,
      errorLoadingAllCounty
    }
  ]
}

// Export a hook that matches the provider's API for backward compatibility
export const useLongitudinalStateCounty = () => {
  const [
    {
      county: states,
      loadingCounty: loadingCountyState,
      refetchCounty: refetchCountyState,
      errorLoadingCounty: errorLoadingCountyState
    }
  ] = useQueryCountyState()

  return {
    states,
    loadingCountyState,
    refetchCountyState,
    errorLoadingCountyState
  }
}
